export default "__VITE_ASSET__2f4a6a50__"